export default __webpack_public_path__ + "static/MNSMCHERRIESSATINJACKET_600x600-226cdd20393a6736a5acb965c1125632.png";